//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

type ItemId = Opaque<string, 'ItemId'>;

function ItemIdFactory(itemId: string) {
  return itemId as ItemId;
}

const ItemId = Object.assign(
  ItemIdFactory,
  {},
);

export default ItemId;
